let articles = [
  // {
  //  `slug: `windows-localhost-ssl-fix`,
  //  `image: `ev-no-company.png`,
  //  `description: ``,
  //  `title: `Fix localhost SSL warnings on Windows`,
  //  `date: `18 Nov 2015`
  // },{
  //  `slug: `browser-identity-ui`,
  //  `image: `loyalty-cards.jpg`,
  //  `title: `How browser identity UI has changed over time`,
  //  `description: ``,
  //  `date: `12 Apr 2015`
  // },{
  //  `slug: `where-the-private-keys-are`,
  //  `image: `datacenter.jpg`,
  //  `title: `The public key is on every device in the world. Where's the private key?`,
  //  `description: `Mystery revealed.`,
  //  `date: `12 Apr 2015`
  // },{
  //  `slug: `extract-certs-from-chrome`,
  //  `image: ``,
  //  `title: `Inspecting certificates from real websites with openssl`,
  //  `description: ``,
  //  `date: `12 Apr 2015`
  // },{
  //  `slug: `how-high-is-openssl-high`,
  //  `image: `how-high.jpg`,
  //  `title: `How high is OpenSSL's HIGH?`,
  //  `description: ``,
  //  `date: `12 Apr 2015`
  // },{
  //  `slug: `calculating-ecc-strength`,
  //  `image: `elliptic-curves.png`,
  //  `title: `So you're making an ECC key for an HTTPS certificate. What key size do you use?`,
  //  `description: `How to measure ECC keys and how they stack up against RSA`,
  //  `date: `24 Aug 2016`
  // },{
  // 	slug: `why-your-https-is-gray`,
  // 	image: `https-gray.jpg`,
  // 	title: `The busy person's guide to determining why your HTTPS is grey.`,
  // 	description: ``,
  // 	date: `11 Jul 2016`
  // },{
  // 	slug: `the-certsimple-story`,
  // 	image: `certsimple-office.jpg`,
  // 	title: `The CertSimple Story.`,
  // 	description: `The inside story on how CertSimple became the only EV-HTTPS focused certificate provider`,
  // 	date: `24 Aug 2016`
  // },{
  // 	slug: `why-ev-https-tls-ssl`,
  // 	image: `fixme.jpg`,
  // 	title: `Why high trust companies get EV HTTPS certificates`,
  // 	description: `Not always about phishing.`,
  // 	date: `23 Jun 2017`
  // },{
  // 	slug: `https-in-plain-english`,
  // 	image: `fixme.jpg`,
  // 	title: `Modern HTTPS concepts in plain English`,
  // 	description: `Certificate transparency, CAA, OCSP, and more.`,
  // 	date: `23 Jun 2017`
  // },{
  // 	slug: `what-every-programmer-should-know-about-linux`,
  // 	image: `airbnb-verification-send-id.png`,
  // 	title: `what every programmer should know about linux`,
  // 	description: ``,
  // 	date: `23 Jun 2017`
  // },{
  // 	slug: `what-every-programmer-should-know-about-linux`,
  // 	image: `airbnb-verification-send-id.png`,
  // 	title: `How do you know you\re on Google? what every programmer should know about linux`,
  // 	description: ``,
  // 	date: `23 Jun 2017`
  // },{
  // 	slug: `verification-whatsapp-twitter-https`,
  // 	image: `airbnb-verification-send-id.png`,
  // 	title: `Identity verification compared`,
  // 	description: `How to get verified on WhatsApp, Twitter, App Stores, Debian, and the web.`,
  // 	date: `25 Jun 2018`
  // },{
  // 	slug: `localhost-ssl-fix-windows`,
  // 	image: `localhost-ssl-fix/trusted-localhost-edge.png`,
  // 	title: `Never see localhost HTTPS warnings on Windows 10 again. Nothing to install.`,
  // 	description: `Setting up working localhost on Windows takes 5 minutes.`,
  // 	date: `30 Aug 2018`
  // },

  // {
  //   slug: `how-to-automate-scary-things`,
  //   image: `x.png`,
  //   title: `How to automate scary things`,
  //   description: `x`,
  //   date: `12 Dec 2020`,
  //   isOldBlog: false,
  // },
  // {
  //   slug: `how-to-work-with-people-outside-your-organisation`,
  //   image: `x.png`,
  //   title: `How to work on technical issues with people outside your organisation`,
  //   description: `x`,
  //   date: `12 Dec 2020`,
  //   isOldBlog: false,
  // },
  // {
  //   slug: `speeding-up-ci-by-not-doing-things`,
  //   image: `x.png`,
  //   title: `Speeding up CI but not doing things`,
  //   description: `x`,
  //   date: `12 Dec 2020`,
  //   isOldBlog: false,
  // },
  // {
  //   slug: `the-fail-safe-pattern`,
  //   image: `x.png`,
  //   title: `The failsafe / scheduler pattern`,
  //   description: `x`,
  //   date: `12 Dec 2020`,
  //   isOldBlog: false,
  // },
  // {
  //   slug: `use-links-in-your-comments`,
  //   image: `x.png`,
  //   title: `Use links in your comments`,
  //   description: `x`,
  //   date: `12 Dec 2020`,
  //   isOldBlog: false,
  // },
  // {
  //   slug: `using-vs-understanding-git`,
  //   image: `x.png`,
  //   title: `Using vs understanding git`,
  //   description: `x`,
  //   date: `12 Dec 2020`,
  //   isOldBlog: false,
  // },
  {
    slug: `chrome-verification-markers`,
    image: `chrome-no-ev.png`,
    title: `Chrome will no longer show verification markers - CertSimple is shutting down.`,
    description: `Thanks for everything`,
    date: `14 Jun 2019`,
    isOldBlog: false,
  },
  {
    slug: `nginx-brotli`,
    image: `operating-press-at-minsk-automotive-plant.jpg`,
    title: `'You can't use Brotli for dynamic content'`,
    description: `And other horses**t.`,
    date: `4 Apr 2017`,
    updatedDate: `25 Jun 2018`,
    isOldBlog: true,
  },
  {
    slug: `onion-ev-ssl`,
    image: `next-gen-onion.png`,
    title: `Onion TLS/SSL certificate updates`,
    description: `Streamlining verification for Onion sites.`,
    date: `26 Mar 2018`,
    isOldBlog: true,
  },
  {
    slug: `break-the-web`,
    image: `why-we-cant-have-nice-things.png`,
    title: `Break the web.`,
    description: `Favoring a bigger future over a tiny past.`,
    date: `9 Mar 2018`,
    isOldBlog: true,
  },
  {
    slug: `deploy-node-on-linux`,
    image: `wooden-door.jpg`,
    title: `The ultimate guide to deploying your node app on Linux`,
    description: `This time we do the work for you.`,
    date: `12 Feb 2018`,
    isOldBlog: true,
  },
  {
    slug: `err-cert-common-name-invalid`,
    image: `err-cert-common-name-invalid.png`,
    title: `CERT COMMON NAME INVALID doesn't mean what you think it does`,
    description: `Standards change, error codes don't`,
    date: `9 Feb 2018`,
    isOldBlog: true,
  },
  {
    slug: `haproxy-http2-dynamic-load-balancing-ssl`,
    image: `haproxy.svg`,
    description: `A load balancer with HTTP/2 and dynamic reconfig.`,
    title: `HAProxy in 2018`,
    date: `8 Jan 2018`,
    isOldBlog: true,
  },
  {
    slug: `debugging-and-troubleshooting-javascript-async-await`,
    image: `waiting.jpg`,
    title: `How to diagnose and troubleshoot JavaScript async/await issues`,
    description: ``,
    date: `19 Sep 2017`,
    isOldBlog: true,
  },
  {
    slug: `browser-security-indicators`,
    image: `apf-browser-security-indicators.png`,
    title: `Chrome's 'Secure' indicator was designed to make users proceed on any HTTPS site`,
    description: `Research pushes users to continue rather than understand`,
    date: `02 Aug 2017`,
    isOldBlog: true,
  },
  {
    slug: `ev-https-sole-proprietor`,
    image: `face-to-face-verification.jpg`,
    title: `Better HTTPS verification for smaller companies`,
    description: `Going straight to face to face verification for sole proprietors and partnerships.`,
    date: `25 Jul 2017`,
    isOldBlog: true,
  },
  {
    slug: `flattening-javascript-async-await`,
    image: `flat-horizon.jpg`,
    title: `How to flatten JavaScript`,
    description: `Using 'await' instead of callbacks and .then()`,
    date: `10 Jul 2017`,
    updatedDate: `02 Aug 2017`,
    isOldBlog: true,
  },
  {
    slug: `javascript-equals-async-await`,
    image: `javascript-equals-async-await.png`,
    title: `ES2017's async/await is the best thing to ever happen to JavaScript`,
    description: `No callbacks, no .then()`,
    date: `20 Jun 2017`,
    isOldBlog: true,
  },
  {
    slug: `ecc-https-certificate-support`,
    image: `ecc-blur.jpg`,
    title: `ECDSA HTTPS certificates are faster and more secure. Here's where you (still) can't use them.`,
    description: `Where to go - and where not to - when you want something better than RSA`,
    date: `17 May 2017`,
    isOldBlog: true,
  },
  {
    slug: `ev-https-france-japan-malaysia`,
    image: `texas-desert.jpg`,
    title: `Adding EV HTTPS prechecks for 7 new countries, and a new US state`,
    description: `🇯🇵 🇲🇾 🇫🇷 🇨🇭 🇸🇰 🇲🇩 🇬🇬 and 🤠`,
    date: `13 Apr 2017`,
    isOldBlog: true,
  },
  {
    slug: `nginx-http2-load-balancing-config`,
    image: `nginx.png`,
    title: `An nginx config for 2017`,
    description: `With HTTP/2 in every browser, load balancing with automatic failover, IPv6, a sorry page, separate blog server, HTML5 SSE and A+ HTTPS.`,
    date: `13 Feb 2017`,
    isOldBlog: true,
  },
  {
    slug: `certsimple-v5-doing-business-as-ev-https`,
    image: `certsimple-v5.png`,
    title: `CertSimple 5: 'Doing Business As' support, instant rekeying, flat pricing`,
    description: `Getting closer to our goal`,
    date: `30 Jan 2017`,
    isOldBlog: true,
  },
  {
    slug: `single-multi-domain-https-certificates-are-the-same-thing`,
    image: `same-thing.jpg`,
    title: `Ignore your CA: 'Single domain' and 'multi domain' HTTPS certificates are the same thing`,
    description: `Ending an arbitrary distinction that wastes everyone's time`,
    date: `5 Jan 2017`,
    isOldBlog: true,
  },
  {
    slug: `your-connection-to-this-site-is-not-private`,
    image: `american-apparel-insecure.png`,
    title: `It's happened: current Chrome is warning users about insecure pages`,
    description: `First transition in Google's HTTPS-everywhere plans is done`,
    date: `2 Sep 2016`,
    isOldBlog: true,
  },
  {
    slug: `make-ecc-https-cert`,
    image: `ecc-shiny.png`,
    title: `CertSimple now defaults to ECC`,
    description: `Build a custom ECC keypair with a single paste on Unix or Windows`,
    date: `25 Jul 2016`,
    isOldBlog: true,
  },
  {
    slug: `safe-curves-and-openssl`,
    image: `curve25519.png`,
    title: `Safe ECC curves for HTTPS are coming sooner than you think`,
    description: `Making ECC better by simplifying it`,
    date: `25 Jul 2016`,
    isOldBlog: true,
  },
  {
    slug: `certsimple-version-4`,
    image: `loyalty-cards.jpg`,
    title: `Automating the non-automatable`,
    description: `How to compel your users with the endowed progress effect`,
    date: `11 Jul 2016`,
    isOldBlog: true,
  },
  {
    slug: `product-development-for-non-us-markets`,
    image: `dancing-couple.jpg`,
    title: `Find love overseas`,
    description: `Simple ways to make people outside the US love your product`,
    date: `12 Jun 2016`,
    isOldBlog: true,
  },
  {
    slug: `https-certificate-chains`,
    image: `budapest-chain-bridge.jpeg`,
    title: `Why you're always at least two steps down your HTTPS certificate chain`,
    description: `And everything else you always wanted to know about certificate chains.`,
    date: `4 May 2016`,
    isOldBlog: true,
  },
  {
    slug: `encryption-everywhere`,
    image: `waves.jpg`,
    title: `Encryption Everywhere: Symantec announce free DV certs via partners.`,
    description: `We told you.`,
    date: `15 Mar 2016`,
    isOldBlog: true,
  },
  {
    slug: `reddit-math-crypto`,
    image: `reddit-math.png`,
    title: `5700 upvotes later: be careful about crypto advice from Reddit.`,
    description: `Watch out where you get our advice from`,
    date: `11 Feb 2016`,
    isOldBlog: true,
  },
  {
    slug: `unix-things-web-developers-struggle-with`,
    image: `killjobs.png`,
    title: `Unix things web developers often struggle with - and how to fix them`,
    description: `And how to fix them`,
    date: `11 Feb 2016`,
    isOldBlog: true,
  },
  {
    slug: `site-seal-ssl`,
    image: `trust-seals-are-rubbish.png`,
    title: `Why 'site seals' are even worse than you thought`,
    description: `Ultimately benefit the vendor more than their customers`,
    date: `28 Jan 2016`,
    isOldBlog: true,
  },
  {
    slug: `ssl-why-do-i-need-it`,
    image: `why-do-i-need-ssl.png`,
    title: `HTTPS provides more than just privacy`,
    description: `Identity, SEO, HTML5, and not having your content modified`,
    date: `25 Jan 2016`,
    isOldBlog: true,
  },
  {
    slug: `ssl-or-tls`,
    image: `not-a-hoverboard.jpg`,
    title: `Why people who know better still say 'SSL'. And 'hoverboard'.`,
    description: `It's 17 years since TLS was standardised. Is it time to move on?`,
    date: `13 Jan 2016`,
    isOldBlog: true,
  },
  {
    slug: `domain-validated-ssl-google-com-mg`,
    image: `google-com-mg.png`,
    title: `Domain validated HTTPS certs issued for google.com.mg and google.com.im`,
    description: `This isn't Google, but they're not fake - that's just what DV HTTPS is.`,
    date: `11 Jan 2016`,
    isOldBlog: true,
  },
  {
    slug: `openssl-shortcuts`,
    image: `openssl-shortcuts.png`,
    title: `You won't remember the options for OpenSSL, so here's bash shortcuts for everything.`,
    description: `Save a bunch of time by pasting this into your .bash_profile`,
    date: `4 Jan 2016`,
    isOldBlog: true,
  },
  {
    slug: `obsolete-cipher-suite-and-things-web-developers-should-know-about-ssl`,
    image: `hungarian-state-opera-house.jpg`,
    title: `What web developers should know about HTTPS but probably don't.`,
    description: `The most common questions we get from developers who already know their stuff`,
    date: `21 Dec 2015`,
    isOldBlog: true,
  },
  {
    slug: `control-the-ssl-cas-your-browser-trusts`,
    image: `root-stores/android-remove-cnnic.png`,
    title: `Who your browser trusts, and how to control it.`,
    description: `Don't want to trust Lenovo, Dell or the Chinese givernment? You don't have to.`,
    date: `21 Dec 2015`,
    isOldBlog: true,
  },
  {
    slug: `domain-validated-ssl-will-be-free`,
    image: `desert.jpg`,
    title: `Domain validated HTTPS will soon be free from the large CAs`,
    description: `Upcoming plans revealed from two of the largest commercial CAs`,
    date: `20 Nov 2015`,
    isOldBlog: true,
  },
  {
    slug: `ssl-wireshark-mac-osx`,
    image: `wireshark.jpg`,
    title: `Wireshark 2 is the simplest way to inspect HTTPS on your Mac`,
    description: `Avoid setting up proxies using only Chrome and Wireshark`,
    date: `19 Nov 2015`,
    isOldBlog: true,
  },
  {
    slug: `certsimple-version-3`,
    image: `live-validation.png`,
    title: `CertSimple 3: realtime EV HTTPS validation, webcrypto, and Delaware!`,
    description: `More industry firsts as we further disrupt a stagnant industry`,
    date: `12 Nov 2015`,
    isOldBlog: true,
  },
  {
    slug: `node-js-ssl-labs`,
    image: `node-4-ssl.png`,
    title: `node.js v4 gets an A+ for SSL Labs with no configuration`,
    description: `We could have written a blog article about how to configure node, or we could just configure node for everybody.`,
    date: `29 Oct 2015`,
    isOldBlog: true,
  },
  {
    slug: `localhost-ssl-fix`,
    image: `localhost-ssl-fix/trusted-localhost.png`,
    title: `Never see localhost HTTPS warnings again`,
    description: `Setting up working localhost on your Mac takes 5 minutes.`,
    date: `17 Sep 2015`,
    isOldBlog: true,
  },
  {
    slug: `csp-shenanigans`,
    image: `shenanigans.jpg`,
    title: `Practical prevention of web shenanigans with Content Security Policy`,
    description: `Save a bunch of time by leveraging known CSP settings for Stripe, YouTube, Twitter and other popular embedded JavaScript apps`,
    date: `1 Sep 2015`,
    isOldBlog: true,
  },
  {
    slug: `ev-ssl-outside-the-us`,
    image: `globe.svg`,
    title: `How we fixed EV validation outside the US`,
    description: `Sweden loves us.`,
    date: `18 Aug 2015`,
    isOldBlog: true,
  },
  {
    slug: `domain-validated-ssl`,
    image: `edge-dv.png`,
    title: `Why we don't sell domain validated HTTPS certificates`,
    description: `Knowing whose private key you're encrypting with is important`,
    date: `17 Aug 2015`,
    isOldBlog: true,
  },
  {
    slug: `new-ssl-tools`,
    image: `new-ssl-tools.png`,
    title: `HTTPS tools we wish we\'d known about earlier`,
    description: `...and that you'll wish you knew about earlier too`,
    date: `20 July 2015`,
    isOldBlog: true,
  },
  {
    slug: `dv-ssl-in-microsoft-edge`,
    image: `edge.svg`,
    title: `Edge uses a hollow gray lock for domain validated HTTPS`,
    description: `Joins Safari in reducing security indicators for domain validated HTTPS`,
    date: `20 July 2015`,
    isOldBlog: true,
  },
  {
    slug: `are-ev-ssl-certificates-worth-it`,
    image: `ev-https-proves-identity.png`,
    title: `A no-bull technical guide to EV HTTPS`,
    description: `You deserve a better explanation of EV than a CA yelling 'trust' at you. `,
    date: `2 July 2015`,
    updatedDate: `11 Jan 2017`,
    isOldBlog: true,
  },
  {
    slug: `seal-in-search`,
    image: `seal-in-search/seal-in-search-missing-citation.png`,
    title: `Strange things are afoot with Symantec\'s search results injection`,
    description: `Company pulls report used for single-size study to justify fake SEO after being called on it`,
    date: `1 July 2015`,
    isOldBlog: true,
  },
  {
    slug: `checking-orders-before-you-pay`,
    image: `order-checking.png`,
    title: `Checking your order before you pay`,
    description: `We're moving more of the validation to the front of the process`,
    date: `5 June 2015`,
    isOldBlog: true,
  },
  {
    slug: `sgc-ssl-certificates`,
    image: `ie5-40-bit.png`,
    title: `Symantec stopped upselling IE5 support in 2015`,
    description: `It runs on Windows 3.1 and until recently Symantec wanted $500 to support it.`,
    date: `19 May 2015`,
    isOldBlog: true,
  },
  {
    slug: `chrome-outdated-cryptography`,
    image: `outdated-cryptography.png`,
    title: `Why your 'A' grade HTTPS is 'outdated cryptography' on Chrome`,
    description: `The difference between SSL Labs and Chrome Security UI`,
    date: `14 May 2015`,
    isOldBlog: true,
  },
  {
    slug: `six-weeks-in`,
    image: `company-search.png`,
    title: `Six weeks in`,
    description: `Our first few weeks of CertSimple`,
    date: `5 May 2015`,
    isOldBlog: true,
  },
  {
    slug: `recreating-unix-rosetta-stone`,
    image: `command-line-rosetta-stone-operating-systems.png`,
    title: `We\'re recreating the Unix Rosetta Stone for 2015`,
    description: `Bringing back the classic with modern OSs and commands`,
    date: `29 April 2015`,
    isOldBlog: true,
  },
  {
    slug: `measuring-ssl-rsa-keys`,
    image: `measuring-rsa-keys/gnfs.png`,
    title: `So you're making an RSA key for an HTTPS certificate. What key size do you use?`,
    description: `Or: why you probably don't want a 4096 bit RSA cert`,
    date: `23 April 2015`,
    isOldBlog: true,
  },
  {
    slug: `junk-free-whois`,
    image: `whois-small.png`,
    title: `Why there\'s junk in your whois results, and how you can get rid of it`,
    description: `YOU.DONT.HAVE.TO.READ.ALL.THESE.FAKE.RESULTS.ABOUT.MICROSOFT.COM`,
    date: `22 April 2015`,
    isOldBlog: true,
  },
  {
    slug: `fortune-500-ssl`,
    image: `fortune-500-ev-ssl-vs-non-ev-ssl-preview.png`,
    title: `EV HTTPS in the Fortune 500`,
    description: `How many companies use EV and who they are`,
    date: `16 April 2015`,
    isOldBlog: true,
  },
  {
    slug: `openssl-csr-command`,
    image: `sha1-chrome.png`,
    title: `Your OpenSSL CSR command is out of date`,
    description: `Here's what 'openssl req' looks like in 2015`,
    date: `13 April 2015`,
    isOldBlog: true,
  },
  {
    slug: `node-ssl-config`,
    image: `npm-logo.svg`,
    title: `Implementing Mozilla\'s recommended HTTPS settings on node & npm`,
    description: `We ported Mozilla's guidelines to node`,
    date: `31 March 2015`,
    isOldBlog: true,
  },
  {
    slug: `a-plus-node-js-ssl`,
    image: `a-plus-ssl/before-and-after.png`,
    title: `How to get A+ on the SSL Labs test in node.js`,
    description: `Actually, go read our next article because we just patched node to include these as default!`,
    date: `24 March 2015`,
    isOldBlog: true,
  },
  {
    slug: `wildcard-ev-certificate`,
    image: `wildcard-phishing.png`,
    title: `Why can\'t I get a wildcard EV certificate?`,
    description: `The short answer: bankofamerica.com-fraud.ph`,
    date: `15 March 2015`,
    isOldBlog: true,
  },
  {
    slug: `do-ev-ssl-certificates-have-better-encryption`,
    image: `ev-subject-cropped.png`,
    title: `Do EV certificates provide better encryption than non-EV certificates?`,
    description: `No. The security benefit is matching public keys to identity.`,
    date: `6 March 2015`,
    isOldBlog: true,
  },
];

export default articles;
